import React from 'react';

export interface Props {
  label: string;
  value: string;
  labelClass?: string;
  labelWidth?: string | number;
  textBoxWidth?: string | number;
  textBoxClass?: string;
  onClick?: (e) => void;
  disabled?: boolean;
}

const LabelWithTextBox = (props: Props) => {
  const {
    label,
    value,
    labelWidth = '20%',
    textBoxWidth = '80%',
    labelClass,
    textBoxClass,
    onClick,
    disabled,
  } = props;

  return (
    <div id={`labelwithtextbox-wrapper`} className="flex flex-row mb-2 h-8 w-full">
      <div
        id={`labelwithtextbox-wrapper-label-${label}`}
        style={{ width: labelWidth }}
        className={`flex h-8 items-center ${labelClass}`}
      >
        {label}
      </div>
      <div
        id={`labelwithtextbox-value-${value}`}
        onClick={disabled ? null : onClick}
        style={{ width: textBoxWidth }}
        className={`border-solid border-[1px] border-[#C2C2C2] rounded-[2px] ${textBoxClass} ${
          disabled ? 'bg-[#e0e0e0]' : 'bg-white'
        }`}
      >
        {value}
      </div>
    </div>
  );
};

export default LabelWithTextBox;
